import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssetDetail,
  updateAsset,
  unloadAssetDetail
} from "../../redux/actions/asset.actions";
import EventList from "../../components/EventList";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import Graph from "../../components/widgets/Graph";
import * as DateHelper from "../../utils/date.formatter";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function Asset({}) {
  let { key } = useParams();
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAssetDetail(key));
    return () => dispatch(unloadAssetDetail()); // => componentWillUnmount
  }, [key]);
  // const handleSubmit = (name) => dispatch(updateAsset(key, name))

  if (!asset.asset) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"assets"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  const events = asset.events;
  const temp_events = events
    ? events.filter(i => i.type === "TEMPERATURE")
    : [];
  const last_temp_event = temp_events
    ? temp_events[temp_events.length - 1]
    : null;

  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"assets"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/assets/${asset.asset.key}/edit`}
                >
                  {t("system.edit_button")}
                </Link>
                <h2>{asset.asset.name}</h2>
              </div>
              {last_temp_event ? (
                <ul className="dashboard-list">
                  <li>
                    <strong>{t("common.label_last_check")}</strong>
                    <em>{last_temp_event.value}°C</em>
                  </li>
                  <li>
                    <strong>{t("common.label_last_seen")}</strong>
                    <em>{DateHelper.toLocalString(last_temp_event.created)}</em>
                  </li>
                  <li>
                    <img
                      className="avatar"
                      alt={""}
                      src={asset.asset.location || "../default-user.jpg"}
                    />
                  </li>
                </ul>
              ) : (
                <ul className="dashboard-list">
                  <li>
                    <strong>{t("asset.label_phone")}</strong>
                    <em>{asset.asset.phone}</em>
                  </li>
                  <li>
                    <strong>{t("common.status")}</strong>
                    <em>{"Normal"}</em>
                  </li>
                  <li>
                    <strong>{t("common.created")}</strong>
                    <em>{DateHelper.toLocalDateString(asset.asset.created)}</em>
                  </li>
                </ul>
              )}
              <hr className="break" />

              <Graph data={temp_events} />
              <hr className="break" />
            </div>
            <div className="content-wrap">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/events/add?from=asset&assetkey=${asset.asset.key}&sitekey=${asset.asset.site}`}
                >
                  {t("event.create_button")}
                </Link>
                <h2>{t("event.label_recent_events")}</h2>
              </div>
              <EventList data={events} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Asset;
